import React from 'react';
import { Modal } from 'antd';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';
import Icon, {
  RotateRightOutlined,
  RotateLeftOutlined
} from '@ant-design/icons';

import { LOCALE } from 'constants/intl-wrapper';
import { PDF_FILE_TYPE } from 'constants/signup';

import PDFViewer from 'PDFViewer/PDFViewer';

import { ReactComponent as CloseIcon } from 'assets/bosta-icons/Close.svg';
import { ReactComponent as LeftIcon } from 'assets/bosta-icons/Chevron-left.svg';
import { ReactComponent as RightIcon } from 'assets/bosta-icons/Chevron-right.svg';

import './PreviewImage.less';

class PreviewImage extends React.Component {
  state = {
    rotateRight: 0,
    rotateLeft: 0,
    imageIndex: 0,
    imageDimension: {
      height: 0,
      width: 0
    }
  };

  onRotateToLeft = () => {
    const isCompleted = this.state.rotateLeft === -360;
    let angle = this.state.rotateLeft - 90;
    if (isCompleted) {
      this.handleResetAngle();
      angle = 0;
    }
    this.handleRotation(angle);
    this.setState({ rotateLeft: angle });
  };

  handleResetAngle = () => {
    this.setState({ rotateRight: 0, rotateLeft: 0 });
  };

  onRotateToRight = () => {
    const isCompleted = this.state.rotateRight === 360;
    let angle = this.state.rotateRight + 90;
    if (isCompleted) {
      this.handleResetAngle();
      angle = 0;
    }
    this.handleRotation(angle);
    this.setState({ rotateRight: angle });
  };

  handleRotation = (angle) => {
    const element = document.querySelector('.br-preview-image__container');
    var div = element,
      angle = angle;
    div.style.webkitTransform = 'rotate(' + angle + 'deg)';
    div.style.mozTransform = 'rotate(' + angle + 'deg)';
    div.style.msTransform = 'rotate(' + angle + 'deg)';
    div.style.oTransform = 'rotate(' + angle + 'deg)';
    div.style.transform = 'rotate(' + angle + 'deg)';
  };

  handleClose = () => {
    const { close, previewImage, onCloseAction = () => {} } = this.props;
    const { rotateLeft, rotateRight } = this.state;
    onCloseAction({ rotateLeft, rotateRight, imageUrl: previewImage });
    close();
  };

  handleSwitch = () => {
    const currentIndex = this.state.imageIndex;
    const { previewImages = [] } = this.props;
    if (currentIndex < previewImages.length - 1) {
      this.setState({ imageIndex: currentIndex + 1 });
    } else {
      this.setState({ imageIndex: 0 });
    }
  };

  componentDidMount() {
    const { previewImages = [] } = this.props;

    if (previewImages.length) {
      this.previewInterval = setInterval(() => {
        this.handleSwitch();
      }, 5000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.previewInterval);
  }

  render() {
    const {
      intl,
      previewImage,
      previewImages = [],
      previewImageTitle,
      previewTitles = [],
      isSvg,
      showPreviewActions = false,
      switchPreviewActions = false,
      type
    } = this.props;

    return (
      <Modal
        {...this.props}
        footer={null}
        title={
          <>
            <span>{previewImageTitle}</span>
            <CloseIcon onClick={this.handleClose} />
          </>
        }
        onCancel={this.handleClose}
        wrapClassName="br-preview-image-modal"
      >
        {showPreviewActions && (
          <div className="br-preview-image-modal__actions">
            <Icon
              component={RotateLeftOutlined}
              onClick={this.onRotateToLeft}
              className="ant-icon-lg"
            />
            <Icon
              component={RotateRightOutlined}
              onClick={this.onRotateToRight}
              className="ant-icon-lg br-preview-image-modal__actions__rotate-right"
            />
          </div>
        )}
        {isSvg ? (
          previewImage
        ) : (
          <>
            {previewTitles && (
              <span>{previewTitles[this.state.imageIndex]}</span>
            )}
            <div className="br-preview-image__container">
              {switchPreviewActions && (
                <div onClick={this.handleSwitch} className="switch-icon">
                  {intl.locale === LOCALE.EN ? <LeftIcon /> : <RightIcon />}
                </div>
              )}
              {type === PDF_FILE_TYPE ? (
                <PDFViewer src={previewImage} />
              ) : (
                <img
                  src={
                    previewImages?.length
                      ? previewImages[this.state.imageIndex]
                      : previewImage
                  }
                  alt="preview image"
                />
              )}
              {switchPreviewActions && (
                <div onClick={this.handleSwitch} className="switch-icon">
                  {intl.locale === LOCALE.EN ? <RightIcon /> : <LeftIcon />}
                </div>
              )}
            </div>
            {previewImages && (
              <div className="br-preview-image__carousel">
                {previewImages.map((item, i) => (
                  <div
                    className={classnames({
                      active: this.state.imageIndex === i
                    })}
                  ></div>
                ))}
              </div>
            )}
          </>
        )}
      </Modal>
    );
  }
}

export default injectIntl(PreviewImage);
